import React, { useMemo, useCallback, useEffect, useState } from "react";
import MirsTable from "components/general/table/Table";
import CaptionTable from "components/general/table/CaptionTable";
import { isLiveStatus, isFinishedStatus, isStartListStatus } from "helpers/status";
import Status from "components/presentation/Status";
import { useViewport } from 'components/general/useViewPort'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { heatsColumns } from "../swiming/columns";
import LoaderSubComponent from "components/general/LoaderSubComponent";
import Label from "components/general/Label";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinusCircle, faPlusCircle, faCaretDown, faCaretRight } from "@fortawesome/free-solid-svg-icons";
import Collapse from 'react-bootstrap/Collapse';
import { CompetitionFromStore } from "helpers/utils";
import { isTeam } from "../helper/MpnHelpers";
import TableExpanded from "../teams/TableExpanded";

const competition = CompetitionFromStore();
const iconClose = competition === 'EG2023' ? faMinusCircle : faCaretDown;
const iconOpen = competition === 'EG2023' ? faPlusCircle : faCaretRight;

const arrowDown = <FontAwesomeIcon icon={iconClose} />
const arrowUp = <FontAwesomeIcon icon={iconOpen} />


const getConfiguration = ({ rsc, breakPoint, resultStatus, scheduleStatus, configNode, currentIntermediate, heat }) => {
    const isStartList = isStartListStatus(resultStatus);
    const isLive = isLiveStatus(resultStatus);
    const isFinished = isFinishedStatus(resultStatus);
    const isMobile = (breakPoint === "sm" || breakPoint === "xs")
    let configuration = {
        sortBy: [],
        columns: [],
    };


    configuration.sortBy = isStartList ||  isLive
        ? [{ id: 'StartOrder', desc: false }]
        : [{ id: 'Rank', desc: false }]

    
    let intermediates = configNode?.filter(node => node?.type === 'SWIM' && node?.code === 'INTERMEDIATE')?.sort((a, b) => (a?.pos === 'F' ? 100: a?.pos) - (b?.pos === 'F' ? 100: b?.pos));
    intermediates = intermediates ? intermediates : [];
    
    configuration.columns = heatsColumns(intermediates, isMobile,  isLive);
    
    const startListHidden = isStartList ? ['Rank', ...intermediates?.map(i => 'Intermediate' + i?.pos), 'Result', 'Penalty', 'Points', 'Remarks'] : []
    
    const liveHidden = isLive ? ['Rank','Result', 'Penalty', 'Points', 'Remarks'] : []
    
    const finishedHidden = isFinished ? [...intermediates?.map(i => 'Intermediate' + i?.pos), 'StartOrder'] : []
    
    const mobileHidden = isMobile ? [...intermediates?.map(i => i?.pos !== currentIntermediate ? 'Intermediate' + i?.pos : ''), 'Penalty', 'Remarks'] : []
    
    configuration.hiddenColumns = [...mobileHidden, ...startListHidden, ...liveHidden, ...finishedHidden];

    if(!isTeam(rsc)) {
        configuration.hiddenColumns.push('Expander');
    }

    return configuration;
}


const MpnSwimmingHeats = ({ data, phaseData }) => {

    const { mirs_rsc, mirs_competition } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    const resultStatus = data?.results?.status?.code;
    const scheduleStatus = data?.results?.schedule?.status?.code;
    const rsc = data?.results?.eventUnitCode;
    const configNode = data?.config?.extendedConfig

    let currentIntermediate = '1';
    data?.results?.items?.forEach(item => {
        const intermediates = item?.extendedResults?.filter(er => er?.er_code === 'INTERMEDIATE');
        intermediates?.forEach(er => {
            if (er?.er_pos  && er?.er_pos === 'F') {
                currentIntermediate = 'F'
            }else if (er?.er_pos && er?.er_pos > currentIntermediate) {
                currentIntermediate = er?.er_pos
            }
        })
        
    });



    const configEvent = useMemo(() => getConfiguration({
        rsc: rsc,
        breakPoint: breakPoint,
        resultStatus: resultStatus,
        scheduleStatus: scheduleStatus,
        configNode: configNode,
        currentIntermediate: currentIntermediate,
        heat: data?.results?.eventUnitCode?.slice(-1)
    }), [resultStatus, breakPoint, currentIntermediate]);

    const renderRowSubComponent = useCallback(({ row }) => {
        let componentExpanded = (<TableExpanded row={row?.original}/>)
        return (
          <LoaderSubComponent component={componentExpanded} />
        )
      }, []);

      const [open, setOpen] = useState(false);
      const [arrow, setArrow] = useState(arrowUp);
      const [openAll, setOpenAll] = useState(true);
    
      useEffect(() => {
        if (openAll) {
          setArrow(arrowDown)
        } else {
          setArrow(arrowUp)
        }
        setOpen(openAll);
      }, [openAll])
    
      const handleClick = () => {
        if (open) {
          setArrow(arrowUp)
        } else {
          setArrow(arrowDown)
        }
        setOpen(!open);
      }
    
    
      const phaseItems = phaseData?.phaseResults && Array.isArray(phaseData.phaseResults) && phaseData.phaseResults.length > 0 ? phaseData.phaseResults[0].items:  []
      data?.results?.items.map(i => {
          const phaseRes = phaseItems?.find(pi => pi?.athleteCode === i?.participant?.code)
          const res = phaseRes?.resultType === 'POINTS' ? phaseRes?.resultData : '';
          return i.points = res;
  
      });
  
     const caption = <CaptionTable className="bg-secondary"
        leftCol={<><span className="fw-bold"><Label data="HeaderHeat" /> {data?.results?.eventUnitCode?.slice(-1)}</span></>}
        centerCol=<div></div>
        rightCol={
            <>
                <div className="d-flex bg-secondary">
                    <Status typeToPrint="result" scheduleStatus={scheduleStatus} resultStatus={resultStatus} />
                    <div className="arrow ms-3" onClick={(e) => handleClick()}>{arrow}</div>
                </div>
            </>
        }
    />

    //to avoid empty table
      return (
        <> 
        {(data?.results) 
            ?
            <>
            <div className="bg-secondary">
                {caption}
            </div>
            <Collapse in={open} className="mb-3">
                <MirsTable
                    data={data?.results?.items}
                    columns={configEvent.columns}
                    keyRow='participant-code'
                    //caption={caption}
                    //Columns to hidde 
                    hiddenColumns={configEvent.hiddenColumns}
                    //When show tble is sorted by 
                    initialSortBy={configEvent.sortBy}
                    id={`mirs-table-result-${rsc}`}
                    renderRowSubComponent={renderRowSubComponent}
                    expandRows={true}
                    //showNavExtendedData={false}
                    //hasRelatedTimeline={true}
                />
            </Collapse>
            </>
            : ''
            }
        </>

    );
};

export default MpnSwimmingHeats;
